module.exports = __webpack_public_path__ + "img/03-5.f7f907a5.png";